// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"0010c1c5","453":"c83767f0","648":"96e00b4a"}[chunkId] + ".chunk.js";
};